<app-title-bar titleText="i18n.base.login.header"></app-title-bar>
<div class="login-wrapper d-flex">
  <img class="login_logo" src="../../../assets/img/logo.svg">
  <div>
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group">
          <label for="userName">{{ "i18n.base.login.userName" | translate }}</label>
          <input id="userName" type="text" class="form-control" placeholder="{{ 'i18n.base.login.userName' | translate }}"
            formControlName="userName">
            <app-error-messages [control]="loginForm.controls.userName"></app-error-messages>
          </div>
          <div class="form-group">
            <label for="password">{{ "i18n.base.login.password" | translate }}</label>
            <input id="password" type="password" class="form-control" placeholder="{{ 'i18n.base.login.password' | translate }}" formControlName="password" appPasswordVisibility>
            <app-error-messages [control]="loginForm.controls.password"></app-error-messages>
          </div>
          <div class="form-group">
            <label for="twoFactorAuthenticationToken">{{ "i18n.shared.two-factor-authentication-token" | translate }}</label>
            <input id="twoFactorAuthenticationToken" type="text" class="form-control" placeholder="{{ 'i18n.shared.two-factor-authentication-token' | translate }}"
              formControlName="twoFactorAuthenticationToken" autocomplete="otp">
              <app-error-messages [control]="loginForm.controls.twoFactorAuthenticationToken"></app-error-messages>
            </div>
            <button type="submit" class="btn btn-primary btn-right">
              @if (loading) {
                <div class="spinner-border spinner-border-sm me-3" role="status"></div>
              }
              {{ "i18n.base.login.login" | translate }}
            </button>
            <a class="btn btn-link btn-right me-2" [routerLink]="[recover2FARoute]">
              {{ "i18n.base.login.recover-2FA" | translate }}
            </a>
            <a class="btn btn-link btn-right" [routerLink]="[forgotPasswordRoute]">
              {{ "i18n.base.login.forgot-password" | translate }}
            </a>
            <a class="btn btn-link btn-right" [routerLink]="[register2FARoute]">
              {{ "i18n.base.login.register-2FA" | translate }}
            </a>
          </form>
        </div>
      </div>
    </div>
